export default __webpack_public_path__ + "static/media/promo-author.86e1ae8a.png";